export const PATH_TO_ORDER = '/order'
